import auditTrailAdmin from './audit-trail/portal-admin';
import auditTrailMerchant from './audit-trail/portal-merchant';
import bankAsClient from './service-log/bank-as-client';
import bankAsServer from './service-log/bank-as-server';
import callbackApiLog from './service-log/callback-api-log';
import inquiryMerchant from './service-log/inquiry-merchant';
import internalService from './service-log/internal-service';
import merchantApi from './service-log/merchant-api';
import mobileApiLog from './service-log/mobile-api-log';


export default {
  auditTrailAdmin,
  auditTrailMerchant,
  bankAsClient,
  merchantApi,
  internalService,
  inquiryMerchant,
  bankAsServer,
  mobileApiLog,
  callbackApiLog
};
